import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHookSection } from './components/OpeningHookSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedApproachesSection } from './components/FailedApproachesSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { WhoIsForSection } from './components/WhoIsForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { PricingSection } from './components/PricingSection';
import { FooterSection } from './components/FooterSection';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-brand-gray selection:bg-brand-amber/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHookSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <FailedApproachesSection data-id="element-4" />
      <MechanismSection data-id="element-5" />
      <WhatYouGetSection data-id="element-6" />
      <WhoIsForSection data-id="element-7" />
      <HowItWorksSection data-id="element-8" />
      <ProofSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <PricingSection data-id="element-11" />
      <FooterSection data-id="element-12" />
    </div>;
}